module.exports = __webpack_public_path__ + "static/img/lixian.68d5a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/lixian.png
// module id = 9Q+g
// module chunks = 24